exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".autosaver{position:fixed;top:78px;right:30px;z-index:100;text-align:center;padding:3px 10px;background:#fff;border-radius:3px;font-size:.8em}.autosaver .deleteDraft,.autosaver .saveForLater{margin-bottom:0;display:inline-block;padding-top:0;padding-bottom:0}.autosaver .saveForLater{padding-left:0;padding-right:0;min-width:88px!important;margin-top:5px}.autosaver .draftSpinner{position:relative;bottom:5px;display:inline-block;width:29px;left:-3px}.autosaver .btn-link.deleteDraft:focus{outline:none}.autosaver .confirmDelete{padding-right:0}.autosaver.autosaverDelete{width:15%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/quizzes/autosaver.scss
// module id = 1495
// module chunks = 0